import { RoomActivityFeed } from '@/components/RoomActivityFeed';
import { useRoomContext } from './context';

/** The room’s tamper-evident, view-only activity log, as a plain-language feed. */
export function RoomActivityPage() {
  const { roomId } = useRoomContext();
  return <RoomActivityFeed roomId={roomId} />;
}
